import { render, staticRenderFns } from "./Dialogs.vue?vue&type=template&id=db5d48e4&scoped=true"
import script from "./Dialogs.vue?vue&type=script&lang=js"
export * from "./Dialogs.vue?vue&type=script&lang=js"
import style0 from "./Dialogs.vue?vue&type=style&index=0&id=db5d48e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5d48e4",
  null
  
)

export default component.exports